if (!customElements.get('cart-note-drawer')) {
  class CartNoteDrawer extends HTMLElement {
    constructor() {
      super();
    }

    addEventListeners() {
      document.addEventListener('alexa:open-cart-note-drawer', (event) => {
        event.preventDefault();
        this.initCartNoteDrawer();
      });

      this.$closeBtn.addEventListener('click', this.closeCartNoteDrawer.bind(this));

      if(this.$button) this.$button.addEventListener('click', this.handleSubmit.bind(this));
    };

    async fetchCart() {
      const response = await fetch('/cart.js');
      const json = await response.json();

      return json;
    }

    async handleSubmit(event) {
      event.preventDefault();

      const cartData = await this.fetchCart();
      const messageNote = this.querySelector('#cart-note');
      let formData = {}
      let cartNote = cartData.note;

      if (cartNote.includes('ORDER NOTE')) {
        cartNote = cartNote.split('\r\nORDER NOTE')[0];
      }

      if (messageNote.value) {
        cartNote += `\r\nORDER NOTE: ${messageNote.value}`;
      }

      formData.note = cartNote;

      updateQuantity(formData);

      this.closeCartNoteDrawer();
    }

    initCartNoteDrawer() {
      this.showCartNoteDrawer();
    };

    showCartNoteDrawer() {
      this.$cartNoteDrawer.classList.add('is-active');
    };

    closeCartNoteDrawer() {
      this.$cartNoteDrawer.classList.remove('is-active');
    };

    connectedCallback() {
      this.$cartNoteDrawer = document.querySelector('.js-cart-note-drawer');
      this.$closeBtn = this.$cartNoteDrawer.querySelector('.js-cart-note-drawer-close');
      this.$successMessage = this.querySelector('.js-drawer-success');
      this.$cartPageDrawerClose = document.querySelector('.js-cart-note-drawer-close-cart-page');
      this.$button = this.querySelector('.js-gift-submit');

      if (this.$cartPageDrawerClose) {
        this.$cartPageDrawerClose.addEventListener(
          'click',
          this.closeCartNoteDrawer.bind(this)
        );
      }

      this.addEventListeners();
    }
  }

  customElements.define('cart-note-drawer', CartNoteDrawer);
}
